import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Formik, Form } from "formik";
import { FieldGroup, FormButton, ChangesIndicator } from "@td/ui";
import { default as DeleteButton } from "./task_form";
import { useTypes } from "../contexts/types-context";
import { taskFormSchema } from "../validations";
import { fieldTypes } from "../constants";
import { isEqual } from "lodash";
import Notes from "./Notes";
import {
  AssigneeField,
  CategoryField,
  ChecklistField,
  ConsultField,
  DueDateField,
  GroupField,
  MemberField,
  NotConsultRelatedField,
  NotesField,
  ProviderField,
  StatusField,
  TaskNameField,
  TaskTypeField,
  UrgentField,
} from "../fields";

const TaskForm = React.memo(({ initialValues, task, onSubmit, buttonText, deleteButtonText, handleDelete }) => {
  const taskTypes = useTypes();

  const resolveFields = useCallback((values) => ([
    [
      <ConsultField />,
      <NotConsultRelatedField />,
    ],
    (!!values[fieldTypes.MEMBER].value || values[fieldTypes.NOT_CONSULT_RELATED]) && (
      <MemberField />
    ),
    !!values[fieldTypes.GROUP] && <GroupField />,
    !!values[fieldTypes.PROVIDER] && <ProviderField />,
    [
      <TaskTypeField />,
      <UrgentField />,
    ],
    (values[fieldTypes.TASK_TYPE] && values[fieldTypes.TASK_TYPE].value === taskTypes.OTHER) && (
      <TaskNameField />
    ),
    <CategoryField />,
    <AssigneeField />,
    <StatusField />,
    <DueDateField />,
    <ChecklistField />,
    !!task ? (
      <Notes
        taskId={task.id}
        notes={task.notes}
      />
    ) : (
      <NotesField />
    ),
  ]), []);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={taskFormSchema}
      onSubmit={onSubmit}
    >
      {({ values }) => (
        <React.Fragment>
          {!isEqual(initialValues, values) && (
            <ChangesIndicator />
          )}

          <Form>
            {resolveFields(values).map((field, index) => (
              <React.Fragment>
                {!!field && (
                  <FieldGroup key={index}>
                    {field}
                  </FieldGroup>
                )}
              </React.Fragment>
            ))}

            <FormButton type="submit">
              {buttonText}
            </FormButton>
            {!!task ? (
              <DeleteButton
                type="button"
                onClick={()=>handleDelete(task.globalId)}
              >{deleteButtonText}
              </DeleteButton>
            ) : ("")
            }
          </Form>
        </React.Fragment>
      )}
    </Formik>
  );
});

TaskForm.propTypes = {
  initialValues: PropTypes.object.isRequired,
  task: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  buttonText: PropTypes.string.isRequired,
  deleteButtonText: PropTypes.string,
  handleDelete: PropTypes.func
};

export default TaskForm;
